import React, {useEffect, useState} from 'react'
import { Carousel } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import StepsView from './steps-view'
import DNSConfiguration from './dns-container'
import GetStartedContainer from './get-started-container'
import { TransparentButton, SolidButton } from '../../../../library/button'
import { changeCampaignsModal, requestDomainDnsConfig, requestDomainVerification } from '../../../../../redux/actions/campaigns'
import { Popup } from '../../../../library/popup'
import './style.scss'

const Index = () => {

	const dispatch = useDispatch()

	const modalState = useSelector(state => state.campaigns.showModals.completeSetupModal)
    const [stepProgress, setStepProgress] = useState(0)

    const details = useSelector(state => state.campaigns.activeChannel.source.status.dns)
    const activeChannel = useSelector(state => state.campaigns.activeChannel)

    const verificationLoading = useSelector(state => state.campaigns.initializeDomain.verification.loading)
    const verificationStatus = useSelector(state => state.campaigns.initializeDomain.verification.status)
    const verificationError = useSelector(state => state.campaigns.initializeDomain.verification.error)

    const handleClose = () => {
		dispatch(changeCampaignsModal({completeSetupModal: false}))
	}

    const clickVerify = () => {
        dispatch(requestDomainVerification({id: details.id, username: activeChannel.username}))
    }

    const renderVerificationProgress = () => {
        switch(stepProgress){
            case 0:
                return 50
            case 1:
                return 100
            default:
                return 50
        }
    }

    useEffect(() => {
        if(verificationStatus && verificationStatus === "success"){
            setStepProgress(1)
        }
    }, [verificationStatus])

    const renderNextButton = () => {
        if(verificationLoading){
            return <SolidButton disabled={true} color="blue" icon={<i className="fas fa-circle-notch fa-spin"></i>} title="Verifiserer" type="button"/>
        }
        if(stepProgress === 2 && verificationStatus){
            return <SolidButton onClick={() => handleClose()} color="blue" title="Kom i gang" type="button"/>
        }
        return <SolidButton onClick={() => clickVerify()} color="blue" title="Fullfør verifisering" type="button"/>
    }

    return(
        <Popup 
			onClose={handleClose}
			show={modalState} 
			title="Fullfør verifisering"
			description="Lim inn verdiene fra tabellen nedenfor i dine DNS innstillinger for å fullføre oppsettet og verifiseringen."
			buttons={[
				<TransparentButton title="Avbryt" type="button" data-dismiss="modal" onClick={() => handleClose()} />,
				renderNextButton()
			]}
		>
            <div className="complete-setup-content-container">
                <StepsView stepProgress={stepProgress} renderVerificationProgress={renderVerificationProgress}/>
                <div className="modal-content-container">
                    <Carousel activeIndex={stepProgress} indicators={false} controls={false}>
                        <Carousel.Item className="selection-item">
                            <DNSConfiguration details={details}/>
                        </Carousel.Item>
                        <Carousel.Item className="selection-item">
                            <GetStartedContainer/>
                        </Carousel.Item>
                    </Carousel>
                </div>
            </div>
        </Popup>
    )
}

export default Index
